import {ActivatedRoute, Router} from '@angular/router';
import {Component, OnInit} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {Keys, StorageService} from '../service/storage.service';
import {BreadcrumbLabel, HasBreadcrumb} from '../borrow/borrower-dashboard/breadcrumbs/breadcrumb';
import {HttpClient} from '@angular/common/http';
import { BrowserUtil } from '../utils/browser.util';
import { AccountService } from '../service/finzy-flex/account/account.service';
import { Toaster, Type } from '../toaster/Toaster';
import { LoanService } from '../service/finzy-flex/loan/loan.service';

@Component({
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.css'],
    providers: [ApiServiceService,AccountService]
})
export class DocumentsComponent implements OnInit, HasBreadcrumb {
    contract: string;

    nach: string;
    dpn: string;
    pdf: string;
    nodoc = false;
    contractexists = false;
    nachexists = false;
    dpnexists = false;
    pdfexists = false;
    loan_id: string;
    finzyDomain = true;
    otherDomain = false;
    isReferralSchemeEnabled: boolean;
    mongoLoanId: string;

    constructor(
        private http: HttpClient, 
        private router: Router,
        private ref: ApiServiceService,
        private storageService: StorageService, 
        private route: ActivatedRoute,
        private browserUtil: BrowserUtil,
        private accountService: AccountService,
        private readonly loanService: LoanService
        ) {
    }
    openFromMobile(fileUrl, download = false) {

        // let webkit = this.browserUtil.nativeWindow.webkit;
        // if (webkit) {
        //     e.preventDefault();
        //     e.stopPropagation();
            
        //     let url = e.target.href;
        //     if (!url) {
        //         url = e.target.parentNode.href;
        //     }
            // var msg = JSON.stringify({ 'action': (download) ? 'download_file' : 'open_external', 'url': url });
            // webkit.messageHandlers.cordova_iab.postMessage(msg);
        if (fileUrl) {
            this.downloadContractDoc(fileUrl);
        }
        // TODO this has to be accomadated as per new s3 private bucket
        if (this.mongoLoanId) {
            this.onDownloadLoanAgreement(this.mongoLoanId);
        }
        // }
    }
    async ngOnInit(): Promise<void> {
        this.isReferralSchemeEnabled = ApiServiceService.isReferralSchemeEnabled();

        const loanId = this.route.snapshot.params.loanId;
        this.mongoLoanId = loanId;
        await this.getSignedDocumentsForLoan(loanId);
    }

    private async getSignedDocumentsForLoan(loanId: string): Promise<void> {
        this.http.post<any>(this.ref.baseURL() + 'getSignedDocuments',
            {
                token: this.storageService.getItem(Keys.TOKEN),
                loan_id: loanId,
                profile_id: this.storageService.getItem(Keys.PROFILE_ID)
            }).subscribe((response) => {
            if (response.status === 'success') {
                this.loan_id = response.loan_info.generated_loan_id;
                if (response.loan_info.signed_document.length > 0) {
                    for (let i = 0; i < response.loan_info.signed_document.length; i++) {
                        if (response.loan_info.signed_document[i].type == 'contract') {
                            this.contractexists = true;
                            this.contract = response.loan_info.signed_document[i].source;
                        }
                        if (response.loan_info.signed_document[i].type == 'nach') {
                            this.nachexists = true;
                            this.nach = response.loan_info.signed_document[i].source;
                        }
                        if (response.loan_info.signed_document[i].type == 'dpn') {
                            this.dpnexists = true;
                            this.dpn = response.loan_info.signed_document[i].source;
                        }
                        if (response.loan_info.signed_document[i].type == 'pdf') {
                            this.pdfexists = true;
                            this.pdf = response.loan_info.signed_document[i].source;
                        }
                    }
                } else {
                    this.nodoc = true;
                }
            } else {
                this.nodoc = true;
            }
        });
    }

    async breadcrumb(): Promise<BreadcrumbLabel> {
        return BreadcrumbLabel.Documents;
    }

    public async downloadContractDoc(fileUrl: string) {
        try {
            const fileName = fileUrl.slice(fileUrl.lastIndexOf('/')+1); 
            this.accountService.getFileByName(fileName)
                .then((res) => {
                    let downloadUrl = URL.createObjectURL(res);
                    let downloadElem = document.createElement('a');
                    downloadElem.href = downloadUrl;
                    downloadElem.download = `${fileName}`;
                    downloadElem.click();
                })
                .catch((err) => {
                    console.log(err)
                })
        } catch(e) {
            console.log(e)
        }
    }

    public async onDownloadLoanAgreement(loanId: string) {
        try {
            const response = await this.loanService.getConsolidatedSignedDocument(loanId);
            if(response.size) {
                const interestCertificateFile = response;
                let downloadUrl = URL.createObjectURL(interestCertificateFile);
                let downloadElem = document.createElement('a');
                downloadElem.href = downloadUrl;
                downloadElem.download = `${this.loan_id}-contract.pdf`;
                downloadElem.click();
            } else {
                Toaster.toast('Loan Agreement is not available yet, please check back later!', Type.Error);
            }
                
        } catch(error) {
            Toaster.toast(`Something went wrong`, Type.Error);
        }
    }
}
